import React from 'react'
import classNames from 'classnames'
import { Dropdown } from '@scentregroup/ui'
import map from 'lodash/map'
import { rangesForDate } from '../../helpers/time-ranges'
import { MDate, TimeRange } from '@scentregroup/shared/types/whats-on'
import trackClickEvent from '../../helpers/analytics-utils/track-event'
import {
  categories,
  actions,
  labels,
} from '../../helpers/analytics-utils/constants'
import style from './index.module.scss'

const ALL_DATES = { value: 'any', label: 'Any date' }

interface DateRangeOptions {
  value: string
  label: string
}

export interface DateRangeFilterProps {
  selectedDateRange?: string
  onChange: (selectDateRange: string) => void
  baseDate: MDate
  className?: Parameters<typeof classNames>[number]
  id?: string
  dataTestId?: string
}

const DateRangeFilter = ({
  onChange,
  baseDate,
  className,
  id,
  dataTestId,
  selectedDateRange = ALL_DATES.value,
}: DateRangeFilterProps): JSX.Element => {
  const ranges: TimeRange[] = rangesForDate(baseDate, selectedDateRange)
  const options: DateRangeOptions[] = map(ranges, (item: TimeRange) => ({
    value: item.slug(),
    label: item.name,
  }))

  const onDateRangeChange = (e: React.FormEvent<HTMLSelectElement>): void => {
    trackClickEvent(
      categories.WHATS_HAPPENING_FILTERS,
      actions.DATE_RANGE_SELECT,
      e.currentTarget.value === 'any' ? 'any-date' : e.currentTarget.value
    )
    if (e.currentTarget.value === ALL_DATES.value) {
      onChange('')
    } else {
      onChange(e.currentTarget.value)
    }
  }

  const onDateDropdown = (): void => {
    trackClickEvent(
      categories.WHATS_HAPPENING_FILTERS,
      actions.DATE_RANGE_EXPAND,
      labels.EXPAND
    )
  }

  options.unshift(ALL_DATES)
  return (
    <Dropdown
      classNames={{
        wrapper: classNames(className, style.wrapper),
        field: classNames(style.field, style.fieldOverride),
      }}
      size="SMALL"
      options={options}
      value={selectedDateRange}
      id={id}
      dataTestId={dataTestId}
      onChange={onDateRangeChange}
      onClick={onDateDropdown}
    />
  )
}

export default DateRangeFilter
